import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import LatLng = google.maps.LatLng;
import OverlayView = google.maps.OverlayView;
import {createEVAMarkersOverlay} from "./customOverlay.component";
import {ScreenUtils} from "../../utils/screen.utils";

export interface MapPoint {
	location: {
		latitude: number,
		longitude: number
	},
	infoWindowContent?: string,
	pointIcon: string,
	isActive: boolean,
	markerElement?: any
}

enum GestureHandlingValue {
	NONE = "none",
	COOPERATIVE = "cooperative",
	GREEDY = "greedy",
	AUTO = "auto"
}

const DEFAULT_ZOOM = 8;

@Component({
  selector: 'gmap',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MapComponent implements OnInit {

	@ViewChild('map', {static: true}) gmapElement: any;
	map: google.maps.Map;
	markersOverlay: OverlayView;

	@Input() center: {
		latitude: number,
		longitude: number
	};
	@Input() points: MapPoint[];
	@Input() zoom: number = DEFAULT_ZOOM;
	@Input() draggable: boolean = true;
	@Input() disableUI: boolean = false;
	@Input() mapTypeControl: boolean = false;
	@Input() zoomControl: boolean = true;
	@Input() disableGestures: boolean = false;
	@Input() centerOnClick: boolean = false;

	ngOnInit() {
		this.initMap();
		this.markersOverlay = this.createOverlayAndMarkers();
		this.markersOverlay.setMap(this.map);
		this.setZoomAndPosition();
	}

	initMap() {
		let mapProp = this.getMapConfig();
		this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
	}

	getMapConfig(): any {
		let mapCenter: LatLng = this.calculateMapCenter();
		let gestureHandling = this.getGestureHandlingValue();
		let mapConfiguration = {
			center: mapCenter,
			zoom: this.zoom,
			zoomControl: this.zoomControl,
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_TOP
			},
			fullscreenControl: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			mapTypeControl: this.mapTypeControl,
			draggable: this.draggable,
			disableDefaultUI: this.disableUI,
			gestureHandling: gestureHandling
		};

		return mapConfiguration;
	}

	calculateMapCenter(): LatLng {
		let mapCenter;
		if (this.center) {
			mapCenter = new LatLng(this.center.latitude, this.center.longitude);
		} else if (this.points.length > 0) {
			let firstPoint = this.points[0];
			mapCenter = new LatLng(firstPoint.location.latitude, firstPoint.location.longitude);
		}
		return mapCenter;
	}

	getGestureHandlingValue(): GestureHandlingValue {
		if (this.disableGestures) return GestureHandlingValue.NONE;
		if (ScreenUtils.isMobile()) return GestureHandlingValue.GREEDY;
		return GestureHandlingValue.COOPERATIVE;
	}

	createOverlayAndMarkers(): OverlayView {
		let overlay = createEVAMarkersOverlay(this.map, this.points, this.centerOnClick);
		return overlay;
	}

	setZoomAndPosition() {
		// Calculate maps bounds
		let bounds = new google.maps.LatLngBounds();

		this.points.forEach((point: MapPoint) => {
			bounds.extend(new LatLng(point.location.latitude, point.location.longitude));
		});

		this.map.fitBounds(bounds);
	}

}
